export const statutColor = {
  "Validé": { bg: "#d1fae5", text: "#065f46", border: "#6ee7b7" },
  "En cours": { bg: "#fef3c7", text: "#92400e", border: "#fcd34d" },
  "Non conforme": { bg: "#fee2e2", text: "#991b1b", border: "#fca5a5" },
  "Archivé": { bg: "#f3f4f6", text: "#374151", border: "#d1d5db" },
};

export const verifColor = {
  Conforme: { bg: "#d1fae5", text: "#065f46" },
  "Écart": { bg: "#fee2e2", text: "#991b1b" },
  "À vérifier": { bg: "#fef3c7", text: "#92400e" },
};

export const statutRetraitColor = {
  "Reçue": { bg: "#fef3c7", text: "#92400e", border: "#fcd34d" },
  "En cours de traitement": { bg: "#eff6ff", text: "#1d4ed8", border: "#bfdbfe" },
  "Traitée": { bg: "#d1fae5", text: "#065f46", border: "#6ee7b7" },
  "Refusée": { bg: "#fee2e2", text: "#991b1b", border: "#fca5a5" },
};

export const statutDroitColor = {
  "Reçue": { bg: "#fef3c7", text: "#92400e", border: "#fcd34d" },
  "En cours": { bg: "#eff6ff", text: "#1d4ed8", border: "#bfdbfe" },
  "Complétée": { bg: "#d1fae5", text: "#065f46", border: "#6ee7b7" },
  "Refusée": { bg: "#f3f4f6", text: "#374151", border: "#d1d5db" },
  "Hors délai": { bg: "#fee2e2", text: "#991b1b", border: "#fca5a5" },
};

export const graviteColor = {
  "Mineure": { bg: "#f0fdf4", text: "#15803d", border: "#86efac" },
  "Modérée": { bg: "#fef3c7", text: "#92400e", border: "#fcd34d" },
  "Majeure": { bg: "#fee2e2", text: "#991b1b", border: "#fca5a5" },
  "Critique": { bg: "#fdf2f8", text: "#9d174d", border: "#f9a8d4" },
};

export const statutIncColor = {
  "Détecté": { bg: "#fee2e2", text: "#991b1b", border: "#fca5a5" },
  "En cours d'analyse": { bg: "#fef3c7", text: "#92400e", border: "#fcd34d" },
  "Notifié CNIL": { bg: "#eff6ff", text: "#1d4ed8", border: "#bfdbfe" },
  "Clôturé": { bg: "#f0fdf4", text: "#15803d", border: "#86efac" },
  "Sans suite": { bg: "#f3f4f6", text: "#374151", border: "#d1d5db" },
};

export const risqueTraitementColor = {
  "Faible": { bg: "#d1fae5", text: "#065f46", border: "#6ee7b7" },
  "Modéré": { bg: "#fef3c7", text: "#92400e", border: "#fcd34d" },
  "Élevé": { bg: "#fee2e2", text: "#991b1b", border: "#fca5a5" },
  "Critique": { bg: "#fdf2f8", text: "#9d174d", border: "#f9a8d4" },
};

export const criticiteColor = {
  "Critique": { bg: "#fee2e2", text: "#991b1b", border: "#fca5a5" },
  "Importante": { bg: "#fef3c7", text: "#92400e", border: "#fcd34d" },
  "Normale": { bg: "#eff6ff", text: "#1d4ed8", border: "#bfdbfe" },
  "Faible": { bg: "#f3f4f6", text: "#374151", border: "#d1d5db" },
};
